export var BookingsQueryParams;
(function (BookingsQueryParams) {
    BookingsQueryParams["REFERRAL"] = "referral";
    BookingsQueryParams["STAFF"] = "staff";
    BookingsQueryParams["LOCATION"] = "location";
    BookingsQueryParams["BOOKING_ID"] = "bookingId";
    BookingsQueryParams["SERVICE_ID"] = "service";
    BookingsQueryParams["AVAILABILITY_SLOT"] = "slot";
    BookingsQueryParams["TIMEZONE"] = "timezone";
    BookingsQueryParams["DYNAMIC_PRICING"] = "dynamic-pricing";
    BookingsQueryParams["FILLED_FIELDS"] = "filledFields";
    BookingsQueryParams["PUBLIC_DATA_OVERRIDES"] = "publicDataOverrides";
    BookingsQueryParams["ECOM"] = "ecom";
    BookingsQueryParams["CONTINUE_SHOPPING_URL"] = "continueShoppingUrl";
    BookingsQueryParams["DATE"] = "date";
    BookingsQueryParams["RESOURCE"] = "resource";
})(BookingsQueryParams || (BookingsQueryParams = {}));
export var Referrals;
(function (Referrals) {
    Referrals["BOOKINGS_FORM_WIDGET_WITH_CART"] = "bookings_form_widget_with_cart";
})(Referrals || (Referrals = {}));
export var ReservedSlug;
(function (ReservedSlug) {
    ReservedSlug["CALENDAR_COMPLEX_NAVIGATION"] = "_select-date-time";
})(ReservedSlug || (ReservedSlug = {}));
//# sourceMappingURL=types.js.map